function Learner(callback) {
    if(!this) return new Learner(callback);

    var samples = {};
    var learnTimeout;

    /**
     * Resets learning
     */
    function reset() {
        samples = {};
        clearTimeout(learnTimeout);
    }

    /**
     * Called when the learn procedure of a button has been completed
     */
    function learnComplete() {
        var winner = samples[getSorted()[0]];
        var result = [];
        for (var i = 0; i < winner[0].length; i++) {
            var data = 0;
            for(var j = 0; j < winner.length; j++) {
                data += winner[j][i];
            }
            data = Math.round(data / winner.length);
            result.push(data);
        }
        reset();
        if (typeof callback == 'function') callback(result, winner.length);
    }

    /**
     * Returns a copy of the Object.keys(samples) array but sorted from big to small
     * @return {array} Sorted counts of the samples
     */
    function getSorted() {
        return Object.keys(samples).slice().sort(function(a, b) { return samples[b].length - samples[a].length; });
    }

    /**
     * Learner function
     * Listens to incoming packets
     * @param  {array}  data Sample
     */
    this.learn = function(data) {
        if (!samples[data.length]) samples[data.length] = [];  // Initialize length key
        samples[data.length].push(data);                       // Add samples

        // If this sample is current winner, reset the timer
        if (getSorted()[0] == data.length) {
            clearTimeout(learnTimeout);
            learnTimeout = setTimeout(function() {
                var sorted = getSorted();
                if ((sorted.length == 1 || (samples[sorted[0]].length / samples[sorted[1]].length) > 2) && samples[sorted[0]].length >= 3) learnComplete();
                else reset();
            }, 750);        // Might cause problems if repeat gap >= 750ms - (signal length)
        }
    };
}

module.exports = Learner;
